// extracted by mini-css-extract-plugin
export default {"dealerRow":"z3waG7bG3cuua6uO4pHE"};